export enum SupportEnvironment {
  Develop = 'develop',
  Production = 'production'
}
